import { useQuery, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentCollection } from '../requests';
import type { GetDocumentCollectionRequestType } from '../types';

/**
 * Custom hook to fetch a collection of documents by their IDs.
 *
 * @param documentIds - The IDs of the documents to fetch.
 */
export const useGetDocumentCollection = (
  documentIds?: GetDocumentCollectionRequestType['documentIds'],
) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [API_QUERY_KEYS.documentCollection, documentIds],
    queryFn: async () => {
      const result = await getDocumentCollection({ documentIds: documentIds! });

      if (result && result.length > 0) {
        result.forEach(document => {
          if (!document.error) {
            queryClient.setQueryData(
              [API_QUERY_KEYS.document, { documentId: document.documentId }],
              document.data,
            );
          }
        });
      }

      return result;
    },
    enabled: !!documentIds && documentIds.length > 0,
  });
};
